module.exports = __webpack_public_path__ + "static/uni_rust-2dd2853ae992e253d4002e652c682373.png";